export enum EntityTypes {
    Market = 1,
    BrandCo = 2,
}
